// Offers.jsx
import { useEffect, useRef, useState } from "react";
import Button from "../../reusable/Button";
import { usePreturi } from "../../../utils/preturi";
import "./index.style.css";

const Offers = () => {
  const offersLinkRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const hash = typeof window !== 'undefined' ? window.location.hash : '';

  useEffect(() => {
    const timer = setTimeout(() => {
      if (hash === "#offers" && offersLinkRef.current) {
        (offersLinkRef.current as HTMLAnchorElement).click();
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [hash]);

  const currentPage = "https://esthetiquebasilix.be/#offers";

  const shareOnFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPage)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentPage).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }).catch(() => {
      alert("Lien copié dans le presse-papiers !");
    });
  };

  const { data: preturiData } = usePreturi();
  const offer = preturiData?.offer;
  // Config din DB dacă există; altfel fallback la valorile de septembrie
  // (astfel secțiunea nu dispare dacă API-ul e indisponibil).
  const showPromo = offer ? offer.visible : true;
  const chip = offer?.chipLabel ?? "OFFRE SEPTEMBRE";
  const offerText =
    offer?.text ??
    "En septembre, profitez de notre offre spéciale sur le soin RADIANCE — Traitement à l'ADN de saumon.";
  const offerImage =
    offer?.imageUrl ||
    "https://firebasestorage.googleapis.com/v0/b/esthetiquebasilix-7e531.appspot.com/o/2026-08-29-17-28-22-574.jpg?alt=media&token=1f6458a0-eec8-4d0f-b23f-a4e2c9ffdf3d";
  const ctaLabel = offer?.ctaLabel || "Prendre rendez-vous";

  return (
    <section id="offers" className="offers">
      <div className="offers-background"></div>
      
      <a
        ref={offersLinkRef}
        href="#offres"
        style={{ display: "none" }}
        aria-hidden="true"
        tabIndex={-1}
      >
        Go to Offres
      </a>
      
      <div className="offres-block">
        {/* <h1 className="title">
          NOS OFFRES
          <div className="title-underline"></div>
        </h1> */}
        
        {/* <div className="offers-container">
          <div className="offers-all-text">
            <p className="offers-paragraph">
              Prenez rendez-vous en ligne et bénéficiez de 5 % de réduction sur
              toutes les procédures au Centre Esthétique Basilix.
            </p>
            <Button title="Prendre rendez-vous" />
          </div>
          
          <img
            className="offers-image"
            src="https://firebasestorage.googleapis.com/v0/b/esthetiquebasilix-7e531.appspot.com/o/2025-07-24-15-50-52-153.jpg?alt=media&token=b80141e8-ee05-4849-ba43-d856aa8ef3d3"
            alt="Promotion Centre Esthétique Basilix"
          />
        </div> */}

        {showPromo && (
          <section
            id="offres"
            className="offers-container offers-container-seconde"
          >
            <div className="offers-all-text offers-all-text-seconde">
              {chip && <span className="offer-chip">{chip}</span>}
              <p className="offers-paragraph">{offerText}</p>
              <Button title={ctaLabel} />
            </div>

            <img
              className="offers-image offers-image-seconde"
              src={offerImage}
              alt="Offre – Centre Esthétique Basilix"
            />
          </section>
        )}

        <div className="share-section">
          <span className="share-title">Partager sur:</span>
          
          <div className="share-container">
            <div
              onClick={shareOnFacebook}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  shareOnFacebook();
                }
              }}
              className="share-button share-facebook"
              role="button"
              tabIndex={0}
              aria-label="Partager sur Facebook"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                viewBox="0 0 16 16"
              >
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"></path>
              </svg>
            </div>
            
            <div
              onClick={copyToClipboard}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  copyToClipboard();
                }
              }}
              className={`share-button copy ${copySuccess ? 'copy-success' : ''}`}
              role="button"
              tabIndex={0}
              aria-label="Copier le lien"
            >
              {copySuccess ? (
                <span className="copy-text">Copié!</span>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                  />
                </svg>
              )}
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Offers;